var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.districts.length ? _c('span', {
    staticClass: "client-districts"
  }, _vm._l(_vm.districts, function (district) {
    return _c('span', {
      key: district,
      staticClass: "district-badge",
      attrs: {
        "title": "Okres nehnute\u013Enosti: ".concat(district)
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "aria-hidden": "true"
      }
    }, [_c('path', {
      attrs: {
        "d": "M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z"
      }
    }), _c('circle', {
      attrs: {
        "cx": "12",
        "cy": "10",
        "r": "2.5"
      }
    })]), _c('span', [_vm._v("Okres " + _vm._s(district))])]);
  }), 0) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }